lmApp
    .service('CronService', [
        function () {
            var service = {};

            var days = {
                0: 'Sunday',
                1: 'Monday',
                2: 'Tuesday',
                3: 'Wednesday',
                4: 'Thursday',
                5: 'Friday',
                6: 'Saturday'
            };

            var months = {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December'
            };

            var monthSuffix = function(input) {
                switch (input) {
                    case 1:
                        return '1st';
                    case 2:
                        return '2nd';
                    case 3:
                        return '3rd';
                    case null:
                        return null;
                    default:
                        return input + 'th';
                }
            };

            Number.prototype.pad = function(size) {
                var s = String(this);
                while (s.length < (size || 2)) {s = "0" + s;}
                return s;
            };

            service.cronTimeToText = function(cronTime) {
                var fr = getCronFreq(cronTime);
                if (fr.base === 1) {
                    return "Every minute";
                }
                if (fr.base === 2) {
                    return "Every hour at " + fr.minuteValue;
                }
                if (fr.base === 3) {
                    return "Every day at " + (fr.hourValue).pad() + ':' + (fr.minuteValue).pad();
                }
                if (fr.base === 4) {
                    return "Every week on " + days[fr.dayValue] + " at " + (fr.hourValue).pad() + ':' + (fr.minuteValue).pad();
                }
                if (fr.base === 5) {
                    return "Every month on the " + monthSuffix(fr.dayOfMonthValue) + " at " + (fr.hourValue).pad() + ':' + (fr.minuteValue).pad();
                }
                if (fr.base === 6) {
                    return "Every year on the " + monthSuffix(fr.dayOfMonthValue) + " of " + months[fr.monthValue] + " at " + (fr.hourValue).pad() + ':' + (fr.minuteValue).pad();
                }
                return "N/A";
            };

            var getCronFreq = function(value) {
                var cron = value.replace(/\s+/g, ' ').split(' ');
                var frequency = {base: '1'}; // default: every minute

                if(cron[0] === '*' && cron[1] === '*' && cron[2] === '*' && cron[3] === '*'  && cron[4] === '*') {
                    frequency.base = 1; // every minute
                } else if(cron[1] === '*' && cron[2] === '*' && cron[3] === '*'  && cron[4] === '*') {
                    frequency.base = 2; // every hour
                } else if(cron[2] === '*' && cron[3] === '*'  && cron[4] === '*') {
                    frequency.base = 3; // every day
                } else if(cron[2] === '*' && cron[3] === '*') {
                    frequency.base = 4; // every week
                } else if(cron[3] === '*' && cron[4] === '*') {
                    frequency.base = 5; // every month
                } else if(cron[4] === '*') {
                    frequency.base = 6; // every year
                }
                if (cron[0] !== '*') {
                    frequency.minuteValue = parseInt(cron[0]);
                }
                if (cron[1] !== '*') {
                    frequency.hourValue = parseInt(cron[1]);
                }
                if (cron[2] !== '*') {
                    frequency.dayOfMonthValue = parseInt(cron[2]);
                }
                if (cron[3] !== '*') {
                    frequency.monthValue = parseInt(cron[3]);
                }
                if (cron[4] !== '*') {
                    frequency.dayValue = parseInt(cron[4]);
                }
                return frequency;
            };

            return service;
        }]);
